// Model that represents a skeleton. Components that are passed
// this as the model should render a skeleton state.
export default class Skeleton extends Backbone.Model {
  get defaults () {
    return {
      id: -1
    }
  }
}
